import { render, staticRenderFns } from "./UploadRow.vue?vue&type=template&id=c1280a38&scoped=true"
import script from "./UploadRow.vue?vue&type=script&lang=js"
export * from "./UploadRow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1280a38",
  null
  
)

export default component.exports